import { render, staticRenderFns } from "./mantenimiento_ros.vue?vue&type=template&id=68907473&scoped=true"
import script from "./mantenimiento_ros.js?vue&type=script&lang=js&external"
export * from "./mantenimiento_ros.js?vue&type=script&lang=js&external"
import style0 from "./mantenimiento_ros.vue?vue&type=style&index=0&id=68907473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68907473",
  null
  
)

export default component.exports